import React, { useEffect, useState, useRef, useCallback } from "react";
import styles from "./WalletsTransactions.module.sass";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchFiatDeposits, fetchFiatWithdrawals } from "store/actions";

const WalletsTransactions = () => {
  const dispatch = useDispatch();
  const { fiatDeposits, fiatWithdrawals } = useSelector((state) => state.walletReducer);
  const transactions = [...fiatDeposits.data, ...fiatWithdrawals.data]
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(fetchFiatDeposits());
    dispatch(fetchFiatWithdrawals());
  }, []);
  return (
    <div className={styles.wrap}>

      {/* Table Card */}
      <div className={styles.cardWrapper}>
        <div className={styles.cardHead} >
          {t("Deposits & Withdraw History")}
        </div>
        <div className={styles.card}>
          <div className={`${styles.row} ${styles.head}`}>
            <div className={styles.col}>Transaction Record</div>
            <div className={styles.col}>Type</div>
            <div className={styles.col}>Amount</div>
            <div className={styles.col}>Time</div>
            <div className={styles.col}>Status</div>
          </div>

          {fiatDeposits.loading || fiatWithdrawals.loading ? (
            <div className={styles.loader}>Loading...</div>
          ) : transactions.length > 0 ? (
            transactions?.map((d, index) => (
              <div className={styles.row} key={index}>
                <div className={styles.col}>
                  <div className={styles.recordId}>
                    <div>{d?.recordId}</div>
                  </div>
                </div>
                <div className={styles.col}>
                  <div className={styles.type}>
                    <div>{d?.type}</div>
                  </div>
                </div>
                <div className={styles.col}>
                  <div className={styles.amount}>
                    <div>{d?.amount}</div>
                  </div>

                </div>
                <div className={styles.col}>
                  <div className={styles.time}>
                    <div>{d?.createdAt}</div>
                  </div>
                </div>
                <div className={styles.col}>
                  <div className={styles.status}>
                    <div>{d?.status}</div>
                  </div>

                </div>
              </div>
            ))
          ) : (
            <div className={styles.empty}>{t("No transactions found")}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WalletsTransactions;
